import React from "react";

function Home() {
  return (
    <div className="section-content">
      <h1>
        Hi, I&apos;m Parth Suri <span className="emoji">👋</span>
      </h1>

      <h2>
        Aspiring Data Scientist | Software Developer | Quant Researcher | AI-ML Engineer
      </h2>

      <p>
        I aim to build intelligent systems that merge{" "}
        <strong>mathematical precision</strong> with{" "}
        <strong>computational creativity</strong>. My focus lies in exploring how{" "}
        <strong>data, algorithms, and design</strong> can come together to drive
        smarter, evidence-based decisions.
      </p>

      <p>
        I’m passionate about <strong>quantitative research</strong>,{" "}
        <strong>predictive modeling</strong>, and{" "}
        <strong>AI-driven decision systems</strong>. My goal is to design tools that
        make complex problems measurable, understandable, and solvable, turning
        abstract data into meaningful insights.
      </p>

      <p>
        Whether it’s <strong>analyzing markets</strong>,{" "}
        <strong>optimizing systems</strong>, or{" "}
        <strong>developing machine learning pipelines</strong>, I’m driven by
        curiosity and a deep desire to create solutions that are as efficient as
        they are elegant.
      </p>

      <div className="home-buttons">
        <a href="#projects" className="btn primary">
          View Projects
        </a>
        <a href="#contact" className="btn secondary">
          Let’s Connect
        </a>
      </div>
    </div>
  );
}

export default Home;
